import {useTranslation} from "react-i18next"
import trashIcon from "../../assets/icon/trash.svg"
import {useEcpWorkflowContext} from "../../reactContext/contextCustomHooks/useEcpWorkflowContext"

export default function GlossaryTermCard({index, term, finished}) {
    const {t} = useTranslation()
    const {setEcpWorkflowAction} = useEcpWorkflowContext()

    const handleClick = () => {
        !finished && setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_GLOSSARY_MODAL", payload: {isGlossaryModal: {modal: true, type: "update", index: index}}})
    }

    const deleteTerm = () => {
        setEcpWorkflowAction({type: "ECP_WORKFLOW_IS_CONFIRMATION_MODAL", payload: {isConfirmationModal: {modal: true, id: index, type: "delete-glossary-term"}}})
    }

    return (
        <>
         <li className="glossary-term-list-item">
            <div className="glossary-term-card" onClick={handleClick} style={{cursor: finished && "not-allowed"}}>
                <span>{term.concept}</span>
                <p>{term.definition}</p>
            </div>
            {!finished &&
                <>
                <div className="circle" onClick={deleteTerm}>
                    <img src={trashIcon} alt="" title={t("Delete")}/>
                </div>
                </>
            }
        </li>
        </>
    )
}